import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaGraduationCap, FaCalendarAlt, FaSchool } from "react-icons/fa";

import baseUrl from "../components/baseurl";

const Education = () => {
  const [educationData, setEducationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEducation = async () => {
      try {
        const response = await axios.get(`${baseUrl}/eduget`);
        setEducationData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching education data:", error);
        setIsLoading(false);
      }
    };

    fetchEducation();
  }, []);

  return (
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-indigo-900 mb-4">
          Education & Qualifications
        </h2>
        <div className="h-1 w-24 bg-indigo-500 mx-auto"></div>
        <p className="mt-6 text-gray-600 max-w-2xl mx-auto">
          My academic background and professional certifications that have
          helped shape my career.
        </p>
      </div>

      <div className="max-w-5xl mx-auto">
        {isLoading ? (
          <div className="flex items-center justify-center p-16">
            <div className="relative">
              <div className="h-16 w-16 rounded-full border-t-4 border-b-4 border-indigo-500 animate-spin"></div>
              <div className="absolute top-0 left-0 h-16 w-16 rounded-full border-t-4 border-b-4 border-indigo-200 animate-spin animate-pulse"></div>
            </div>
          </div>
        ) : (
          <div className="space-y-12">
            <div className="relative">
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 top-0 bottom-0 w-1 bg-indigo-200"></div>

              {educationData.map((edu, index) => (
                <div
                  key={edu._id}
                  className={`relative md:flex ${
                    index % 2 === 0 ? "md:flex-row-reverse" : ""
                  } mb-12`}
                >
                  <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-6 h-6 rounded-full bg-indigo-600 border-4 border-white shadow z-10"></div>

                  <div className="md:w-1/2 relative">
                    <div
                      className={`bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 ${
                        index % 2 === 0 ? "md:ml-8" : "md:mr-8"
                      }`}
                    >
                      <div className="flex items-center mb-4">
                        <FaGraduationCap
                          size={24}
                          className="text-indigo-600 mr-3"
                        />
                        <h3 className="text-xl font-bold">{edu.course}</h3>
                      </div>

                      <div className="flex items-center mb-3">
                        <FaSchool className="text-gray-500 mr-2" />
                        <span className="text-gray-700">{edu.institution}</span>
                      </div>

                      <div className="flex items-center text-gray-500">
                        <FaCalendarAlt className="mr-2" />
                        <span>{edu.duration}</span>
                      </div>
                    </div>

                    <div
                      className={`hidden md:block absolute top-1/2 transform -translate-y-1/2 ${
                        index % 2 === 0 ? "left-0 -ml-4" : "right-0 -mr-4"
                      } w-0 h-0 border-solid border-8 ${
                        index % 2 === 0
                          ? "border-l-0 border-r-white"
                          : "border-r-0 border-l-white"
                      } border-y-transparent`}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="md:hidden mt-12 bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-indigo-600 text-white">
                  <tr>
                    <th className="px-4 py-3 text-left">Institution</th>
                    <th className="px-4 py-3 text-left">Course</th>
                    <th className="px-4 py-3 text-left">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  {educationData.map((edu) => (
                    <tr
                      key={edu._id}
                      className="border-b border-gray-200 hover:bg-gray-50"
                    >
                      <td className="px-4 py-3">{edu.institution}</td>
                      <td className="px-4 py-3 font-medium">{edu.course}</td>
                      <td className="px-4 py-3">{edu.duration}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Education;
